import { render, staticRenderFns } from "./FormChangeChromaKeyAlgo.vue?vue&type=template&id=60e89704&"
import script from "./FormChangeChromaKeyAlgo.vue?vue&type=script&lang=js&"
export * from "./FormChangeChromaKeyAlgo.vue?vue&type=script&lang=js&"
import style0 from "./FormChangeChromaKeyAlgo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports